import React from 'react';
import PropTypes from 'prop-types';
import styles from './Training.module.scss';
import Tooltip from '@mui/material/Tooltip';
import TrainingLine from "./TrainingLine";

// Background images
import ARMLogo from '../images/round_FieldIcon.png';
import NewsFlashIcon from '../images/NewItem.png';

// Item Type Icons
// CoPresentIcon for workshops, YouTubeIcon for videos
import {CoPresent} from '@mui/icons-material';
import {YouTube} from '@mui/icons-material';
import {Article} from '@mui/icons-material';
import {Help} from '@mui/icons-material';
import {School} from '@mui/icons-material';

// This needs to be implemented as soon as possible.
// Special notes on file placement:
//   Files of type pdf (which includes the workshop, article & paper types) are to be placed 
//   in the /resources folder on the production server. The URL for these files will include
//   the domain url and the /resources path (e.g. https://armonline.org/resources/filename.pdf).


const TrainingItem = (props) => {

  let entryType = '';
  if (props.BackgroundImage.toLowerCase().includes('workshop')) {
    entryType = 'shop';
  } else if (props.BackgroundImage.toLowerCase().includes('video')) {
    entryType = 'vid';
  } else if (props.BackgroundImage.toLowerCase().includes('article')) {
    entryType = 'art';
  } else if (props.BackgroundImage.toLowerCase().includes('paper')) {
    entryType = 'pap';
  } else {
    entryType = 'unknown';
  }

  const updatedTooltip = () => {
    let prefix = '';
    if (entryType === 'shop') {
      prefix = 'Workshop';
    }
    if (entryType === 'vid') {
      prefix = 'Video';
    }
    if (entryType === 'art') {
      prefix = 'Article';
    }
    if (entryType === 'pap') {
      prefix = 'Paper';
    }

    if (props.Tooltip !== '') {
      return prefix + ': ' + props.Tooltip;
    } else {
      return prefix;   
    }  
  };

  const ItemAgeInDays = () => {
    if (props.AddedDate) {
      const addedDate = new Date(props.AddedDate);
      const currentDate = new Date();
      const timeDiff = currentDate - addedDate;
      const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      return daysDiff;
    }

    return null;
  };
  
  console.log('Item Age in Days: ', ItemAgeInDays());
  
  let flashNew = false;
  if (ItemAgeInDays() !== null && ItemAgeInDays() <= 28) {
    flashNew = true;
  }

  const render_details = () => {
    const {Title, TrainingDate, TrainingTime, Cost, Venue, Registration, URL} = props;

    let formattedDate = '';
    if (TrainingDate) {
      const date = new Date(TrainingDate);

      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var year = date.getFullYear();
      var month = months[date.getMonth()];
      var dateVal = date.getDate();

      formattedDate = dateVal + '-' + month + '-' + year;
    }

    //#region Determine the label for the training time
    let timeLabel;
    const lcTrainingTime = TrainingTime ? TrainingTime.toLowerCase() : '';
    // Check if the training time contains 'minute' or 'hour'
    const durationInds = ['minute', 'hour'];
    const isDuration = durationInds.some(ind => lcTrainingTime.includes(ind));
    if (isDuration) {
      timeLabel = 'Duration: ';
    } 

    // Check if the training time contains 'am' or 'pm'
    const clockTimes = ['am', 'pm'];
    const isClockTime = clockTimes.some(ind => lcTrainingTime.includes(ind));
    if (isClockTime) {
      timeLabel = 'Time: ';
    }
    //#endregion

    return (
      <div key={`item2_${props.id}`} >
        <TrainingLine Label='Title:' Value={Title} Index={props.Id} />
        {TrainingDate && <TrainingLine Label='Date:' Value={formattedDate} Index={props.Id} />}
        {TrainingTime && <TrainingLine Label={timeLabel} Value={TrainingTime} Index={props.Id} />}
        {Cost && <TrainingLine Label='Cost:' Value={Cost} Index={props.Id} />}
        {Venue && <TrainingLine Label='Venue:' Value={Venue} Index={props.Id} />}
        {Registration && <TrainingLine Label='Registration:' Value={Registration} Index={props.Id} />}
        {URL && <TrainingLine Label='' Value={URL} IsURL={true} Index={props.Id} />}
      </div>
    );
  };

  return (
    <div className={styles.itemOuterContainer} >
      <Tooltip 
        title={updatedTooltip()}
        placement="top"
        arrow
        slotProps={{
          popper: {
            modifiers: [
              {name: 'offset', options: {offset: [-20, -14]}, }
            ],
          },
        }}
      >
        <div className={styles.itemInnerContainer} >
          
          {flashNew && <div className={styles.newsFlash}>
              <img src={NewsFlashIcon} alt="New Item" style={{width: '100%', height: '100%'}} />
            </div>}
          <div className={styles.itemLeftSide}>
            <div className={styles.itemImage}>
              <img src={ARMLogo} alt="Field image" style={{width: '100px', height: '100px'}} />
              <div className={styles.itemImageIcon}>
                {entryType === 'shop' && <CoPresent fontSize="48px" />}
                {entryType === 'vid' && <YouTube fontSize="48px" />}
                {entryType === 'art' && <Article fontSize="48px" />}
                {entryType === 'pap' && <School fontSize="48px" />}
                {entryType === 'unknown' && <Help fontSize="48px" />}
              </div>  
            </div>
          </div>

          <div className={styles.itemRightSide} key={`item_${props.Id}`} >
            {render_details()}
          </div>
        </div>  
      </Tooltip>
    </div>
  );
}

TrainingItem.propTypes = {
  Id: PropTypes.number.isRequired,
  Title: PropTypes.string,
  TrainingDate: PropTypes.string,
  TrainingTime: PropTypes.string,
  Cost: PropTypes.string,
  Venue: PropTypes.string,
  Registration: PropTypes.string,
  Tooltip: PropTypes.string,
  URL: PropTypes.string,
  BackgroundImage: PropTypes.string,
  AddedDate: PropTypes.string,
}

TrainingItem.defaultProps = {
  Title: '',
  TrainingDate: '',
  TrainingTime: '',
  Cost: '',
  Venue: '',
  Registration: '',
  Tooltip: '',
  URL: '',
  BackgroundImage: 'video',
  AddedDate: '',
};

export default TrainingItem;
